/* eslint-disable ember/no-mixins */
/* eslint-disable ember/no-classic-components */
import Component from '@ember/component';
import ColPickMixin from 'ember-colpick/mixins/col-pick';
export default Component.extend(ColPickMixin);